module.exports = __webpack_public_path__ + "static/media/like.e6bcda66.png";